export { RibbonAlt as default } from './RibbonAlt';
